// Display permission only. The server independently enforces bundle approval and scopes.
// This must never be used for admin routes, models, picks or research predictions.
export const publicAnalyticsEnabled = () => process.env.REACT_APP_CSB_PUBLIC_FOOTBALL_ANALYTICS === '1';
export const canViewFootballAnalytics = (isAdmin) => !!isAdmin || publicAnalyticsEnabled();
